import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "./Reveal";
import { COMMERCIAL_BENEFITS, AUDIENCES, IMAGES } from "@/lib/content";

export default function PropertyManagers() {
  return (
    <section
      id="partners"
      className="relative bg-surface py-28 md:py-40 border-y border-white/10"
      data-testid="partners"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative overflow-hidden aspect-[4/5]">
                <motion.img
                  src={IMAGES.celebration}
                  alt="Trusted hospitality partner"
                  className="h-full w-full object-cover img-cinematic"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
                />
                <div className="absolute inset-0 border border-white/10 pointer-events-none" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <Overline>Why lodges partner with us</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
                One accountable hospitality{" "}
                <em className="italic text-metallic-gold">partner</em>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 font-sans text-base md:text-lg text-ink/70 max-w-xl leading-relaxed">
                Lodge owners, boutique operators, property managers and travel
                professionals bring us in because we protect what matters most —
                guest experience, reputation and revenue — through one trusted
                point of contact instead of a rotating cast of suppliers.
              </p>
            </Reveal>

            <div className="mt-12">
              <Reveal>
                <span className="font-sans text-[0.65rem] tracking-[0.3em] uppercase text-gold">
                  Who we serve
                </span>
              </Reveal>
              <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 max-w-2xl">
                {AUDIENCES.map((a, i) => (
                  <Reveal key={a} delay={0.03 * i}>
                    <span className="font-sans text-sm text-ash">
                      {a}
                      {i < AUDIENCES.length - 1 ? (
                        <span className="text-gold/60 ml-6">·</span>
                      ) : null}
                    </span>
                  </Reveal>
                ))}
              </div>
            </div>

            <div className="mt-14">
              <Reveal>
                <span className="font-sans text-[0.65rem] tracking-[0.3em] uppercase text-gold">
                  Commercial benefits
                </span>
              </Reveal>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
                {COMMERCIAL_BENEFITS.map((p, i) => (
                  <Reveal key={p} delay={0.04 * i}>
                    <div className="flex items-center gap-4 border-b border-white/10 pb-3">
                      <span className="font-sans text-xs text-gold">
                        0{i + 1}
                      </span>
                      <span className="font-sans text-sm text-ash">{p}</span>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>

            <Reveal delay={0.2}>
              <Link
                to="/book"
                data-testid="partners-cta"
                className="mt-14 inline-flex items-center gap-4 rounded-full bg-black border border-gold/70 px-8 py-4 font-sans text-xs tracking-[0.2em] uppercase text-metallic-gold hover:border-gold hover:bg-black/80 transition-all duration-300"
              >
                Become a Partner →
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
